import { useState } from 'react';
import logodark from "../karuncup-dark-1.svg";

export default function Sidebar({ userData, hasPaid, leagueData, navigate }) {
  const [open, setOpen] = useState(false);

  return (
    <>
      {/* دکمه همبرگر + لوگو برای موبایل */}
      <div className="fixed top-4 right-4 flex items-center md:hidden z-50">
        <img src={logodark} alt="کارون کاپ" className="w-10 h-10 mr-2" />
        <button
          onClick={() => setOpen(prev => !prev)}
          className="p-2 rounded-md text-white bg-slate-800 hover:bg-slate-700 focus:outline-none focus:ring"
        >
          {open ? (
            /* آیکون بستن */
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            /* آیکون همبرگر */
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* سایدبار */}
      <aside
        dir="rtl"
        className={`group/sidebar fixed inset-y-0 right-0 z-40 flex flex-col pt-16 md:pt-2 w-64 lg:w-[300px] bg-slate-800 border-r border-dashed border-r-slate-500 transform transition-transform duration-300 ease-in-out ${
          open ? 'translate-x-0' : 'translate-x-full'
        } md:translate-x-0 md:static md:flex`}
      >
        {/* هدر لوگو */}
        <div className="flex items-center justify-center h-24 px-8">
          <a href="https://www.loopple.com" className="transition-colors duration-200">
            <img src={logodark} alt="Logo" width="96" height="96" />
          </a>
        </div>

        {/* اطلاعات کاربر */}
        <div className="flex items-center justify-between px-8 py-5">
          <div className="flex items-center">
            <img
              className="w-12 h-12 rounded-lg"
              src={userData.teampic}
              alt="avatar"
            />
            <div className="mr-4">
              <a
                href="#"
                className="block text-base font-medium text-lime-500 hover:text-lime-400"
              >
                {userData.username}
              </a>
              <span className="block text-sm text-slate-300">
                {userData.teamrole}
              </span>
            </div>
          </div>
          <button className="text-slate-300 hover:text-lime-500">
            {/* آیکون تنظیمات بصورت inline SVG */}
            <svg xmlns="http://www.w3.org/2000/svg" className="w-6 h-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.594 3.94c.09-.542.56-.94 1.11-.94h2.593c.55 0 1.02.398 1.11.94l.213 1.281c.063.374.313.686.645.87.074.04.147.083.22.127.324.196.72.257 1.075.124l1.217-.456a1.125 1.125 0 011.37.49l1.296 2.247a1.125 1.125 0 01-.26 1.431l-1.003.827c-.293.24-.438.613-.431.992a6.759 6.759 0 010 .255c-.007.378.138.75.43.99l1.005.828c.424.35.534.954.26 1.43l-1.298 2.247a1.125 1.125 0 01-1.369.491l-1.217-.456c-.355-.133-.75-.072-1.076.124a6.57 6.57 0 01-.22.128c-.331.183-.581.495-.644.869l-.213 1.28c-.09.543-.56.941-1.11.941h-2.594c-.55 0-1.02-.398-1.11-.94l-.213-1.281c-.062-.374-.312-.686-.644-.87a6.52 6.52 0 01-.22-.127c-.325-.196-.72-.257-1.076-.124l-1.217.456a1.125 1.125 0 01-1.369-.49l-1.297-2.247a1.125 1.125 0 01.26-1.431l1.004-.827c.292-.24.437-.613.43-.992a6.932 6.932 0 010-.255c.007.378-.138-.75-.43-.99l-1.004-.828a1.125 1.125 0 01-.26-1.43l1.297-2.247a1.125 1.125 0 011.37-.491l1.216.456c.356.133.751.072 1.076-.124.072-.044.146-.087.22-.128.332-.183.582-.495.644-.869l.214-1.281z" />
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
            </svg>
          </button>
        </div>

        <div className="border-b border-dashed border-slate-900"></div>

        {/* لینک‌ها */}
        <nav className="flex-1 overflow-y-auto px-3 my-5 space-y-1">
            {userData.role == "User" && (<button
            onClick={() => navigate('/add-team')}
            className="w-full text-right px-4 py-3 text-lg text-slate-500 hover:text-cyan-500 rounded-lg"
          >
            افزودن اعضای تیم
          </button>)}
          

          {hasPaid && (
            <>
              <a
                href="/certificate"
                className="block px-4 py-3 text-lg text-slate-500 hover:text-cyan-500 rounded-lg"
              >
                دریافت گواهی
              </a>
              <a
                href="/invoice"
                className="block px-4 py-3 text-lg text-slate-500 hover:text-cyan-500 rounded-lg"
              >
                دریافت فاکتور
              </a>
            </>
          )}

          <button
            onClick={() => navigate('/Logout')}
            className="w-full text-right px-4 py-3 text-lg text-slate-500 hover:text-cyan-500 rounded-lg"
          >
            خروج
          </button>

          {/* لیگ */}
          <div className="mt-6 px-4 py-2 border-t border-dashed border-slate-900">
            <span className="text-sm font-semibold text-slate-400 uppercase">
              لیگ {leagueData?.name}
            </span>
          </div>
        </nav>
      </aside>
    </>
  );
}
